<template>
  <v-autocomplete
    v-model="selected"
    :label="label"
    :hint="hint"
    class="required"
    item-text="name"
    item-value="id"
    :search-input.sync="search"
    :items="items"
    :error-messages="errorMessages"
  />
</template>

<script>
import api from '@/api'

export default {
  name: 'LoadSettingInput',
  props: [
    'label',
    'hint',
    'scope',
    'value',
    'defaultValue',
    'errorMessages',
    'environmentOverride',
  ],

  data() {
    return {
      selected: this.value,
      search: '',
      items: [],
      timeout: null,
      abortController: null,
      initial: true,
      loading: false,
    }
  },

  watch: {
    search(name) {
      if (this.initial) {
        this.initial = false

        this.fetchItems('', true)

        return
      }

      clearTimeout(this.timeout)
      this.timeout = setTimeout(() => {
        this.fetchItems(name)
      }, 250)
    },

    selected(value) {
      this.$emit('input', value)
      this.$emit('change', value)
    },

    value(value) {
      this.selected = value
    },

    environmentOverride() {
      this.fetchItems('')
    },
  },

  methods: {
    async fetchItems(name, append = false) {
      if (this.abortController) {
        this.abortController.abort()
      }
      this.abortController = new AbortController()
      const response = await this.fetchLoadSettings(
        '',
        this.scope,
        this.abortController.signal
      )
      this.abortController = null

      if (append) {
        this.items = this.removeDupes([...this.items, ...response.data.data])
      } else {
        this.items = response.data.data
      }
    },

    fetchLoadSettings(name, scope, signal) {
      const config = {
        params: {
          name,
          scope,
          perPage: 100,
        },
        signal,
      }

      if (this.environmentOverride) {
        return api.get(`/${this.environmentOverride}/load_setting`, {
          ...config,
          _global: true,
        })
      }

      return api.get('load_setting', config)
    },

    removeDupes(items) {
      return [
        ...items
          .reduce((map, item) => map.set(item.id, item), new Map())
          .values(),
      ]
    },
  },
}
</script>

<style scoped></style>
